<div class="container">
<p class="alisLogin-text">Attempting to establish connection with ALIS. Please wait. This window will close automatically once registration is complete.</p>
</div>

